import React, { useState, useEffect } from 'react';
import _ from "lodash";
import FileUpload from "../../common/FileUpload";

const container = {
  backgroundColor: '#f5f5f5',
  marginBottom: '3px',
  padding: '5px',
  borderRadius: '5px'
};
const noDamagesInfo = {
  fontStyle: 'italic',
  fontSize: '80%'
};

export default function Part(props) {
  const { label } = props;
  const [damages, setDamages] = useState(props.damages ? props.damages : {});
  const [adding, setAdding] = useState(false);
  const [type, setType] = useState(window.INTERIOR_DAMAGE_TYPES[0].value);
  const [files, setFiles] = useState([]);
  useEffect(() => {
    props.updateDamages(damages);
  }, [damages]);
  return (
    <div className="cell small-12 medium-6 large-4">
      <div style={container}>
        {adding === false && <div className="grid-x grid-margin-x">
          <div className="cell small-9">
            <label><span>{label}</span></label>
            {damages.length > 0 && <div>
              <ul className="damage-list">
                {damages.map((damage, idx) => (
                  <li key={`damage-${idx}`}>{_.find(window.INTERIOR_DAMAGE_TYPES, t => t.value === damage.type).label}
                    <a className="button tiny secondary"
                       title="Usuń"
                       onClick={() => {
                         const newDamages = Object.assign([], damages);
                         newDamages.splice(damages.indexOf(damage), 1);
                         setDamages(newDamages);
                       }}>
                      <i className="fas fa-trash"></i>
                    </a>
                  </li>))}
              </ul>
            </div>}
            {damages.length < 1 && <p style={noDamagesInfo}>Element nie posiada żadnych uszkodzeń</p>}
          </div>
          <div className="cell small-3" style={{ position: 'relative' }}>
            <button className="button hollow absolute-center" onClick={e => {
              e.preventDefault();
              setAdding(true);
              return false;
            }}><i className="fas fa-plus"></i></button>
          </div>
        </div>}
        {adding === true && <div>
          <label><span>{label}</span></label>
          <label>
            Rodzaj:
            <select value={type} onChange={e => {
              setType(e.target.value)
            }}>
              {_.map(window.INTERIOR_DAMAGE_TYPES, (option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))};
            </select>
          </label>
          <div>
            <label>Zdjęcia uszkodzenia:</label>
            <FileUpload updateFileList={files => {
              setFiles(files);
            }}>
              <p>Załącz co najmniej 2 zdjęcia uszkodzonego elementu.</p>
            </FileUpload>
          </div>
          <div className="button-group">
            <button className="button" disabled={_.filter(files, file => file.status === 'READY').length < 2}
                    onClick={(e) => {
                      e.preventDefault();
                      const newDamages = Object.assign([], damages);
                      newDamages.push({
                        type, files
                      });
                      setDamages(newDamages);
                      setAdding(false);
                      return false;
                    }}>OK
            </button>
            <button className="button secondary hollow" onClick={(e) => {
              e.preventDefault();
              setAdding(false);
              return false;
            }}>Anuluj
            </button>
          </div>
        </div>}
      </div>
    </div>
  );
}
